// Vendor Libs
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

// Components
import {useDispatch, useSelector} from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import Form from '../core/form';
import Permissions from '../core/permissions';

// Styles
import './freewheel-config-form.scss';
import Icon from '../core/icon';

// Redux
import {servicesActionPropertiesActions} from '../../actions/services-action-caller-actions';

function FreewheelConfigForm({editing}) {
    const dispatch = useDispatch();
    const {content} = useSelector((state) => state?.servicesActionData?.responsePropertiesGet?.data || []);
    const [counter, setCounter] = useState(0);
    const [endpointDef, setEndPointDef] = useState('');
    const [flagDef, setFlagDef] = useState('');
    const [endpoint, setEndPoint] = useState('');
    const [flag, setFlag] = useState('');
    const [origFwEndpoint, setOrigFwEndpoint] = useState('');
    const [origFwFlag, setOrigFwFlag] = useState('');
    const [fullProperties, setFullProperties] = useState([]);
    const [isEditMode, setEditMode] = useState(false);
    const counterLimit = 2;
    const freewheelVariables = [
        {name: 'endPoint', description: 'Freewheel Endpoint', value: endpoint},
        {name: 'flag', description: 'Freewheel Flag', value: flag},
    ];

    useEffect(() => {
        if (content && content.length) {
            setFullProperties(content);
            const res = content.map((c) => ({
                key: c.key,
                value: c.value,
                defaultValue: c.defaultValue,
                applicationPropertyId: c.applicationPropertyId,
            }));
            const flagFull = res.find((r) => r.key.includes('freewheel.flag')) || '';
            const epFull = res.find((r) => r.key.includes('freewheel.endpoint')) || '';
            setFlagDef(flagFull?.defaultValue);
            setEndPointDef(epFull?.defaultValue);
            setEndPoint(epFull?.value);
            setFlag(flagFull?.value);
            setOrigFwEndpoint(epFull?.value);
            setOrigFwFlag(flagFull?.value);
            setCounter(0);
        } else if (counter < counterLimit) {
            setCounter(counter + 1);
            dispatch(servicesActionPropertiesActions({method: 'get'}));
        } else {
            setEndPoint('');
            setFlag('');
            setCounter(counterLimit);
        }
    }, [content]);

    const updateAddDbRecord = (key, value, defaultValue) => {
        const id = fullProperties.find((r) => r.key.includes(key))?.applicationPropertyId;
        if (id) {
            dispatch(
                servicesActionPropertiesActions({
                    applicationPropertyId: id,
                    key,
                    value,
                    defaultValue,
                    method: 'put',
                })
            );
        } else {
            dispatch(
                servicesActionPropertiesActions({
                    key,
                    value,
                    defaultValue,
                    method: 'post',
                })
            );
        }
    };

    const handleChange = (fieldName, valueInput) => {
        const value = valueInput.toString().length ? valueInput : null;
        if (fieldName === 'flag') {
            setFlag(value);
        } else {
            setEndPoint(value);
        }
    };

    const showField = (variable, index) => (
        <div className="p-field" key={index}>
            <label className="p-d-block" htmlFor={variable.name}>
                {variable.description}
            </label>
            <InputText
                className="p-d-block inputTimer"
                disabled={!isEditMode}
                id={variable.name}
                value={variable.value}
                onChange={(e) => handleChange(variable.name, e.target.value)}
            />
        </div>
    );

    const saveModified = () => {
        setEditMode(false);
        updateAddDbRecord('freewheel.endpoint', endpoint, endpointDef);
        updateAddDbRecord('freewheel.flag', flag, flagDef);
        setCounter(0);
        dispatch(servicesActionPropertiesActions({method: 'get'}));
    };

    const setDefaultValues = () => {
        setFlag(flagDef);
        setEndPoint(endpointDef);
    };

    return (
        <Permissions
            accessRequirement="update"
            elementService="vfb"
            notAuthorizedMessage={true}
            requiresServiceAccess={true}
        >
            {(content && content.length) || counter >= counterLimit ? (
                <Form className="freewheel-config-form">
                    <div className="p-d-flex p-flex-column">
                        {freewheelVariables.map((timerVar, index) => showField(timerVar, index))}
                    </div>
                    {editing && (
                        <div className="freewheel-config-form--controls">
                            <div className="p-d-flex p-flex-row p-jc-left">
                                <Button
                                    className={
                                        isEditMode
                                            ? 'p-button-raised p-button-secondary'
                                            : 'p-button-raised p-button-primary'
                                    }
                                    onClick={() => {
                                        setEditMode(!isEditMode);
                                        if (isEditMode) {
                                            setEndPoint(origFwEndpoint);
                                            setFlag(origFwFlag);
                                        }
                                    }}
                                >
                                    {!isEditMode ? 'Make Changes' : 'Cancel'}
                                </Button>
                                {isEditMode && (
                                    <>
                                        <Button
                                            className="p-button-raised p-button-primary saveButton"
                                            onClick={() => saveModified()}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            className="p-button-raised p-button-info saveButton"
                                            onClick={() => setDefaultValues()}
                                        >
                                            Set Default Values
                                        </Button>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </Form>
            ) : (
                <Icon fontType="fa" iconName="spinner" spin={true} style={{color: '#07619c', padding: 10}} />
            )}
        </Permissions>
    );
}

FreewheelConfigForm.propTypes = {
    editing: PropTypes.bool,
};

export default FreewheelConfigForm;
